module.exports = __webpack_public_path__ + "img/cluster-active.8e2dd5e1.svg";